"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertText = exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Color;
(function (Color) {
    Color["Positive"] = "u-fill-pos";
    Color["Negative"] = "u-fill-neg";
    Color["Warning"] = "u-fill-warn";
})(Color || (Color = {}));
var TextAlign;
(function (TextAlign) {
    TextAlign["Left"] = "u-justify-content-start";
    TextAlign["Right"] = "u-justify-content-end";
})(TextAlign || (TextAlign = {}));
var Alert = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["c-alert", props.color, props.textAlign], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.Alert = Alert;
var AlertText = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["c-alert__text"], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.AlertText = AlertText;
exports.Alert.Color = Color;
exports.Alert.Text = exports.AlertText;
exports.Alert.TextAlign = TextAlign;
//# sourceMappingURL=Alert.js.map